import axios from 'axios';
import wrapper from 'axios-cache-plugin'

const http = axios.create( { baseURL: rtwp.root } );

export const HTTP = http;

export const getSlides = () => http.get('acf/v3/options/front-page-slider');

export const getFooter = () => http.get('acf/v3/options/option');

export const getPosts = (params) => getContentWithParams('posts', params);

export const getRelatedPosts = (params) => getContentWithParams('posts', params);

export const getPostBySlug = (slug) => getContentBySlug('posts', slug);

export const getPageBySlug = (slug) => getContentBySlug('pages', slug);

export const getCaseBySlug = (slug) => getContentBySlug('case', slug);

export const getCaseById = (id) => http.get(`wp/v2/case/${id}`);

export const getCategoryBySlug = (slug) => http.get(`wp/v2/categories?slug=${slug}`);

export const getAuthorBySlug = (slug) => http.get(`wp/v2/posts?author_name=${slug}`);

export const getPostsByCategory = (id) => getContentWithParams('posts', id);

export const getPostsByAuthor = (name) => getContentWithParams('posts', `?author_name=${name}`);

export const getComments = (params) => getContentWithParams('comments', params);

export const getThreadComments = (params) => getContentWithParams('comments', params);

export const postComment = (params) => http.post('wp/v2/comments', params);


const getContentWithParams = (type, params) => {
  let url = `wp/v2/${type}`;
  let data = {
    params
  }

  return http.get(url, data);
}

const getContentBySlug = (type, slug) =>{
  const urlParams = new URLSearchParams(window.location.search);
  const previewId = urlParams.get('preview_id') || urlParams.get('page_id');
  let url = `wp/v2/${type}`;
  let params = { slug };
  if (previewId) {
    url = `wp/v2/${type}/${previewId}/revisions`;
    params = { _wpnonce: rtwp.nonce };
  }
  return http.get(url, {params});
};